<cm-overlay
  header="{{ 'CONFERENCING_INCOMING_VIDEO_CALL' | translate }}"
  width="1000"
  height="600"
  >
  @if (inboundCallOptions$ | async; as inboundCallOptions) {
    <cm-accept-call-with-delay-dialog
      [callOptions]="inboundCallOptions"
    ></cm-accept-call-with-delay-dialog>
  }
</cm-overlay>
